import {getWordWidth} from "./getWordWidth";

/**
 * Преобразует строку в массив строк в зависимости от ширины столбца и размера текста
 * @param name - строка (например Полка перфорированная на 600 мм)
 * @param columnWidthPt - ширина столбца в pt, в который нужно поместить @param "name"
 * @param fontSize - размер текста в pt
 */
export const splitNameIntoRows = (name: string, columnWidthPt: number, fontSize: number): string[] => {
    // 10 запас на отступы
    const columnWidthPx = columnWidthPt - 10
    //заменяем дефисы на пробелы (появляются ошибки)
    const splitName = name.replace('-', ' ').split(' ')
    const stringRows: string[] = []
    let wordsOneRow = ''
    splitName.forEach((word, index, wordsArr) => {
        if (index === 0 && wordsArr.length - 1 === index) {
            stringRows.push(word)
            return
        }
        if (!wordsOneRow) {
            wordsOneRow += word
        } else {
            const wordsWidth = getWordWidth(wordsOneRow + ' ' + word, fontSize)
            if (wordsWidth < columnWidthPx) {
                wordsOneRow = wordsOneRow + ' ' + word
                if (wordsArr.length - 1 === index) {
                    stringRows.push(wordsOneRow)
                }
            } else {
                stringRows.push(wordsOneRow)
                wordsOneRow = word
                if (wordsArr.length - 1 === index) {
                    stringRows.push(wordsOneRow)
                }
            }
        }
    })

    return stringRows
}
